import React, {useEffect, useState} from 'react';
import {useHistory} from 'react-router-dom';
import {useUserDetails} from '../../../hooks/userDetails';
import RouteKey from '../../../routes/key';
import {OrganisationAccess} from '../../../models';
import {useAuth} from '../logic/auth';
import PrivateRoutePage from './PrivateRoutePage';

interface PrivateRouteProps {
  children: React.ReactNode;
  exact?: boolean;
  path: string;
  organisationAccess: OrganisationAccess[];
}

const {auth} = RouteKey.child;
const {login} = RouteKey.auth.child;

function PrivateOrganisationRoute({
                                    children,
                                    exact,
                                    path,
                                    organisationAccess,
                                  }: PrivateRouteProps) {
  const authHook = useAuth();
  const {data, isLoading, refetch} = useUserDetails();
  const history = useHistory();
  const hasAuthorizationPayload =
      Array.isArray(data?.data?.organisationAccess) && data.data.organisationAccess.length > 0;

  const [isMatchedBefore, setIsMatchedBefore] = useState(false);

  useEffect(() => {
    if (data?.data.organisationAccess) {
      const expectedOrganisationAccess: string[] = Object.values(organisationAccess);
      let found = false;
      expectedOrganisationAccess.forEach((item) => {
        if (data?.data.organisationAccess?.find((f) => f.modules.includes(item))) {
          found = true;
        }
      });

      if (found) {
        setIsMatchedBefore(true);
      } else {
        history.replace('/error/generic');
      }
    } else {
      history.replace('/error/generic');
    }
  }, [data?.data.organisationAccess, history, organisationAccess]);

  useEffect(() => {
    if (!authHook.isUserLoggedIn || isLoading || hasAuthorizationPayload) {
      return;
    }

    const intervalId = setInterval(() => {
      refetch();
    }, 1000);

    return () => clearInterval(intervalId);
  }, [authHook.isUserLoggedIn, hasAuthorizationPayload, isLoading, refetch]);

  return (
      <PrivateRoutePage
          authHook={authHook}
          auth={auth}
          exact={exact}
          path={path}
          login={login}
          isMatchedBefore={isMatchedBefore}
          isLoading={isLoading}
      >
        {children}
      </PrivateRoutePage>
  );
}

export default PrivateOrganisationRoute;
